import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { isString } from 'lodash';
import { getPlainText } from 'src/utils';

import { SidebarHeaderProps } from './SidebarHeader.interface';
import {
  SidebarHeaderButton,
  SidebarHeaderContainer,
} from './SidebarHeader.styled';

export const SidebarHeader = (props: SidebarHeaderProps) => {
  return (
    <SidebarHeaderContainer>
      <SidebarHeaderButton
        variant="text"
        startIcon={<ArrowBackIcon />}
        onClick={props.onBackClick}>
        {isString(props.label) ? getPlainText(props.label) : props.label}
      </SidebarHeaderButton>

      {props.rightComponent}
    </SidebarHeaderContainer>
  );
};
